import React from 'react'
import './../styles/componentsStyle/Loader.sass'
import spinnerLogo from '../resources/images/spinner-logo.png'

interface Props {
    isRelativePosition?: boolean
}

const Loader: React.FC<Props> = (props) => {
    return (
        <div className={`loader-container ${props.isRelativePosition ? 'relative-loader' : 'absolute-loader'}`}>
            <div className="loader-spinner">
                <img className="spinner-icon" src={spinnerLogo} alt="spinner" />
            </div>
        </div>
    )
}

export default Loader
